import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import ModalWindow from '../Window';
var useStyles = makeStyles(function (theme) {
  return createStyles({
    content: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  });
}, {
  name: 'ECConfirmation'
});
/**
 * A simple confirmation dialog
 * @param {import('modal/variants/types').ConfirmationProps & import('modal/types').ModalProps} props
 */

var Confirmation = function Confirmation(props) {
  var onClose = props.onClose,
      onConfirm = props.onConfirm,
      message = props.message,
      title = props.title,
      confirmLabel = props.confirmLabel,
      confirmingLabel = props.confirmingLabel,
      confirmColor = props.confirmColor,
      hideCancel = props.hideCancel;
  var classes = useStyles({});

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      errorResponse = _useState2[0],
      setError = _useState2[1];

  var confirmFn = function confirmFn(e) {
    if (errorResponse) setError(null);
    if (!onConfirm) return;
    var promise = onConfirm(e);

    if (promise) {
      return promise.catch(function (action) {
        setError(action.payload);
        throw action;
      });
    }
  };

  var getFooterButtons = function getFooterButtons() {
    var buttons = {};
    buttons['submit'] = {
      children: confirmLabel,
      pendingChildren: confirmingLabel,
      color: confirmColor,
      onClick: confirmFn
    };
    if (!hideCancel) buttons['cancel'] = {};
    return buttons;
  };

  return React.createElement(ModalWindow, {
    onClose: onClose,
    borderLess: true,
    overlay: true,
    header: title,
    error: errorResponse && errorResponse.error,
    content: React.createElement("div", {
      className: classes.content
    }, message),
    footerButtons: getFooterButtons()
  });
};

Confirmation.defaultProps = {
  title: 'Confirm',
  message: 'Are you sure?',
  confirmLabel: 'Confirm',
  confirmingLabel: 'Confirming...',
  confirmColor: 'primary',
  hideCancel: false
};
export default Confirmation;